import React from 'react';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { Site, SiteConfig } from '@99designs/common/apps/global-nav/lib/Site';
import { BackendSubscriptionClientProvider } from 'common/ApolloClient/BackendSubscriptionClientContext';
import { ErrorBoundary } from 'common/ErrorBoundary';
import { IntlProvider } from 'common/I18n/IntlContext';
import ViewerProviderQuery from 'common/Viewer/ViewerContext';
// @ts-ignore
import messages from 'GlobalNavMessages'; // eslint-disable-line import/no-unresolved
import Routes from 'routes';
import { SnackbarProvider } from './common/FloatingAlert/hooks';

interface Props {
    language: string;
    siteConfig: SiteConfig;
    backendSubscriptionClient?: SubscriptionClient;
}

class App extends React.Component<Props> {
    render() {
        const site = new Site(this.props.siteConfig);
        return (
            <IntlProvider locale={this.props.language} messages={messages}>
                <ErrorBoundary site={site}>
                    <SnackbarProvider>
                        <BackendSubscriptionClientProvider
                            value={this.props.backendSubscriptionClient}
                        >
                            <ViewerProviderQuery>
                                <Routes site={site} />
                            </ViewerProviderQuery>
                        </BackendSubscriptionClientProvider>
                    </SnackbarProvider>
                </ErrorBoundary>
            </IntlProvider>
        );
    }
}

export default App;
